@if (this.featureToggleService.isLoaded | async; as isLoaded) {
@if (isLoaded) {
<div class="history-container">
  <div [ngClass]="{'pt-web-access': !isFordPass && !isPerks}" class="history">

    @if(!isFordPass && !isPerks) {
    <section class="history-title">
      <h4>{{ "access-title" | translate}}</h4>
      <p>{{ "access-info" | translate}}</p>
    </section>
    }
    <section class="history-content" id="history-content">
      <app-tabs>
        <app-tab title="{{'select.revision' | translate | uppercase}}" [active]="true" [id]="'btn-revision'">
          <app-revision [vin]="authService.urlInfo.vin" [country]="authService.urlInfo.country" />
        </app-tab>
        <app-tab title="{{'select.attendance' | translate | uppercase}}" [id]="'btn-schedule'">
          <app-schedule [vin]="authService.urlInfo.vin" [country]="authService.urlInfo.country" />
        </app-tab>
        <app-tab title="{{'select.recall' | translate | uppercase }}" [id]="'btn-recall'">
          <app-recall [vin]="authService.urlInfo.vin" [country]="authService.urlInfo.country" />
        </app-tab>
      </app-tabs>
    </section>

    <section class="history-help">
      <div class="history-help__card">
        <img src="./assets/icons/Icon_Information.svg" alt="Information Icon" width="18" />
        <p [innerHtml]="'history.help' | translate"></p>
      </div>
    </section>
  </div>
</div>
}
}
